import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { RotatingLines } from 'react-loader-spinner'
import { useNavigate } from "react-router-dom";

function Login() {

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showLoader, setShowLoader] = useState(false)
    const navigate = useNavigate();

    useEffect(() => {
        const email = localStorage.getItem('USERNAME')
        const password = localStorage.getItem('PASSWORD')
        const isStaff = localStorage.getItem('IS_STAFF')
        const isReceive = localStorage.getItem('IS_RECEIVE')
        const isExcelInward = localStorage.getItem('IS_EXCEL_INWARD')
        if (email && password && isExcelInward === 'TRUE' && isStaff === 'TRUE') {
            navigate('/inward')
        } else if (email && password && isStaff === 'TRUE' && isReceive === 'TRUE') {
            navigate('/receive')
        } else if (email && password && isStaff === 'FALSE' && isReceive === 'TRUE') {
            navigate('/search')
        } else if (email && password && isStaff === 'FALSE' && isReceive === 'FALSE') {
            navigate('/search')
        }
    }, [])

    const saveFCMToken = async () => {
        const email = localStorage.getItem('USERNAME')
        const password = localStorage.getItem('PASSWORD')
        if (localStorage.getItem('FCM_TOKEN')) {
            try {
                const response = await fetch(`${process.env.REACT_APP_PRODUCTION_URL}/saveFCMToken`, {
                    headers: {
                        'Content-type': 'application/json'
                    },
                    method: 'POST',
                    body: JSON.stringify({
                        USERNAME: email,
                        PASSWORD: password,
                        FCM_TOKEN: localStorage.getItem('FCM_TOKEN')
                    }),
                });
                const data = await response.json()
                console.log(data, "DATA123");
            } catch (error) {
                console.log(error, "error");
            }
        }
    }

    const clearLocalStorage = () => {
        localStorage.removeItem('USERNAME')
        localStorage.removeItem('PASSWORD')
        localStorage.removeItem('IS_HOLD')
        localStorage.removeItem('IS_CONFIRM')
        localStorage.removeItem('IS_CLIENT_PRICE')
        localStorage.removeItem('IS_VENDOR')
        localStorage.removeItem('IS_STAFF')
        localStorage.removeItem('IS_RECEIVE')
        localStorage.removeItem('IS_EXCEL_INWARD')
        localStorage.removeItem('IS_VENDOR_NAME')
        localStorage.removeItem('IS_CLIENT_WEB')
        localStorage.removeItem('IS_SHOW_HOLD_BUTTON')
    }

    // Login function called.
    const handleSubmit = async () => {
        setShowLoader(true)
        clearLocalStorage()
        // localStorage.clear()
        if (email === '' || password === '') {
            toast.error('Please enter valid Username or Password!', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            });
            setShowLoader(false)
            return;
        }
        await fetch(`${process.env.REACT_APP_PRODUCTION_URL}/login`, {
            method: 'POST',
            body: JSON.stringify({
                USERNAME: email,
                PASSWORD: password
            }),
            headers: {
                'Content-type': 'application/json'
            },
        })
            .then((response) => response.json())
            .then(async (data) => {
                setShowLoader(false)
                if (data.success === 'TRUE') {
                    localStorage.setItem("USERNAME", email)
                    localStorage.setItem("PASSWORD", password)
                    localStorage.setItem("IS_CONFIRM", data.message.IS_CONFIRM)
                    localStorage.setItem("IS_VENDOR", data.message.IS_VENDOR)
                    localStorage.setItem("IS_HOLD", data.message.IS_HOLD)
                    localStorage.setItem("IS_CLIENT_PRICE", data.message.IS_CLIENT_PRICE)
                    localStorage.setItem("IS_CLIENT_WEB", data.message.IS_CLIENT_WEB)
                    localStorage.setItem("IS_VENDOR_NAME", data.message.IS_VENDOR_NAME)
                    localStorage.setItem("IS_STAFF", data.message.IS_STAFF)
                    localStorage.setItem("IS_RECEIVE", data.message.IS_RECEIVE)
                    localStorage.setItem("IS_EXCEL_INWARD", data.message.IS_EXCEL_INWARD)
                    localStorage.setItem("IS_SHOW_HOLD_BUTTON", data.message.IS_SHOW_HOLD_BUTTON)
                    toast.success(data.message, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "dark",
                    });
                    // if (email.toLowerCase() === 'our') {
                    await saveFCMToken()
                    // }
                    if (data.message.IS_EXCEL_INWARD === 'TRUE' && data.message.IS_STAFF === 'TRUE') {
                        navigate('/inward')
                    } else if (data.message.IS_STAFF === 'TRUE' && data.message.IS_RECEIVE === 'TRUE') {
                        navigate('/receive')
                    } else {
                        navigate('/search')
                    }
                } else {
                    toast.error(data.message.MSG, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "dark",
                    });
                }
            })
            .catch((err) => {
                setShowLoader(false)
            });

    }

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            // Trigger the login function when Enter key is pressed
            handleSubmit();
        }
    };

    return (
        <>
            <ToastContainer />
            <div className="login-container flex flex-col">
                <div className="login-form">
                    <h1 style={{ textAlign: "center" }}>Login</h1>
                    <label htmlFor="username">Username:</label>
                    <input
                        type="text"
                        id="username"
                        name="username"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        className="input"
                        onKeyDown={handleKeyPress}
                    />
                    <label htmlFor="password">Password:</label>
                    <input
                        type="password"
                        id="password"
                        name="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        className="input"
                        onKeyDown={handleKeyPress}
                    />

                    {
                        !showLoader && <button className="button" onClick={handleSubmit}>Login</button>
                    }
                    {
                        showLoader && <button className="button flex justify-center" disabled>
                            <RotatingLines
                                strokeColor="yellow"
                                strokeWidth="10"
                                animationDuration="0.75"
                                width="17"
                                visible={true}
                            />
                        </button>
                    }

                </div>
            </div>
        </>
    );
}

export default Login;
